import React from 'react'
import ILayout from 'interfaces/layout'
import { Layout as BgLayout } from './styles'

export const Layout: React.FC<ILayout> = ({ children }) => {
  return <BgLayout>{children}</BgLayout>
}

export default Layout
